import { ColDef, ValueGetterParams } from "ag-grid-community";
import get from "lodash.get";

export const formatBoolValue = (value: boolean | string): string =>
	value === true || value === "true" ? "Yes" : value === false || value === "false" ? "No" : null;

export function getBooleanColDef(colDef: ColDef): ColDef {
	return {
		valueGetter: (params: ValueGetterParams): string => {
			if (!params || !params.data) return undefined;
			const value: boolean = get(params.data, colDef.field);
			return formatBoolValue(value);
		},
		// filter: "agSetColumnFilter", // enterprise features
		// filterParams: {
		// 	...DEFAULT_FILTER_PARAMS,
		// 	values: ["Yes", "No", undefined],
		// },
		// type: "booleanColumn",
		fieldType: "boolean",
		...colDef,
	} as ColDef;
}
